export const COVERAGE_DETAIL_INFO_OPEN_MODAL = "COVERAGE_DETAIL_INFO_OPEN_MODAL";